import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import {
  authenticated,
  authenticatedFailed,
  refreshTokenAction,
  refreshTokenDispatched,
  refreshTokenSuccessAction,
} from "../actions/Auth";
import {
  SIGNIN,
  REFRESH_TOKEN,
  REFRESH_TOKEN_FAILURE,
  SIGNOUT,
} from "../constants/Auth";
import JwtAuthService from "../../services/JwtAuthService";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { FormattedMessage } from "react-intl";
import { END_POINTS } from "constants/APIConstant";
import axios from "axios";
import { API_BASE_URL, APP_PREFIX_PATH } from "configs/AppConfig";

// // Function to simulate API call to refresh token
const refreshTokenAPI = async (refreshToken, token) => {
  try {
    const headers = {
      Authorization: `bearer ${token}`,
    };
    var result = await axios.post(
      `${API_BASE_URL}/${END_POINTS.REFRESH_TOKEN}?token=${refreshToken}`,
      null,
      {
        headers: headers,
      },
    );

    return result;
  } catch (error) {}
};

// Saga for handling sign in
export function* signIn(action) {
  //yield takeLatest(SIGNIN, function* ({ payload }) {
  const { personalKey, password } = action.payload;

  try {
    const user = yield call(JwtAuthService.login, personalKey, password);
    if (user && user.state) {
      const data = (user.data ?? user) || {};
      const emailNotConfirmed = data.emailNotConfirmed;
      const userId = data.userId ?? data.id ?? null;
      if (emailNotConfirmed) {
        const now = Date.now();
        const parsedResetTime = data.resetTime
          ? new Date(data.resetTime).getTime()
          : NaN;
        const effectiveResetTime =
          !Number.isNaN(parsedResetTime) && parsedResetTime > now
            ? new Date(parsedResetTime).toISOString()
            : new Date(now + 10 * 60 * 1000).toISOString();

        const verificationData =
            userId != null ? { userId, resetTime: effectiveResetTime } : null;

        if (verificationData && typeof sessionStorage !== "undefined") {
          localStorage.setItem("emailVerificationCountDownTimer", effectiveResetTime);
          sessionStorage.setItem(
            "emailVerificationData",
            JSON.stringify(verificationData),
          );
        }

        window.location.href = `${APP_PREFIX_PATH}/verify-email`;
        return;
      } else {
        if (data.isVerified) {
          const message = user.message;
          const {
            accessToken,
            refreshToken,
            roles,
            permissions,
            agencyName,
            id,
            email,
            fullName,
            firstName,
            lastName,
            userName,
            isPaid,
            subscripitionExpiryDate,
            phoneNumber,
          } = data;
          yield put(
            authenticated(
              accessToken,
              refreshToken,
              agencyName,
              id,
              email,
              roles,
              permissions,
              message,
              fullName,
              firstName,
              lastName,
              userName,
              isPaid,
              subscripitionExpiryDate,
              phoneNumber,
            ),
          );
          yield put(
            apiResponseMessage({
              showMessage: true,
              message: <FormattedMessage id="login-sucess" />,
              messageType: MESSAGE_TYPE.SUCCESS,
            }),
          );
          yield delay(300000);
          yield put(refreshTokenAction(refreshToken)); // Call refreshToken after successful login
        } else {
          window.location.href = `${APP_PREFIX_PATH}/resetPass/${userId}`;
        }
      }
    } else {
      yield put(authenticatedFailed());
      return;
    }
  } catch (err) {
    yield put(authenticatedFailed());
    return;
  }
}

function* refreshTokenSaga() {
  try {
    const refreshToken = yield select((state) => state.auth.refreshToken);
    const token = yield select((state) => state.auth.token);
    var valid =
      token &&
      refreshToken &&
      token !== undefined &&
      refreshToken !== undefined;
    if (valid) {
      const response = yield call(refreshTokenAPI, refreshToken, token);
      if (response?.data.state) {
        yield put(refreshTokenSuccessAction(response.data.data));
        yield put(refreshTokenDispatched());
        yield delay(300000); // Delay for 5 minutes before calling refreshToken again
        yield put(refreshTokenAction(refreshToken)); // Call refreshToken again after 5 minutes
      } else {
        yield put({ type: REFRESH_TOKEN_FAILURE, error: "Failure" });
        yield put({ type: "SIGNOUT" });
      }
    }
  } catch (error) {
    yield put({ type: REFRESH_TOKEN_FAILURE, error: error.message });
    // yield put(
    //   apiResponseMessage({
    //     showMessage: true,
    //     message: <FormattedMessage id="login-sucess" />,
    //     messageType: MESSAGE_TYPE.SUCCESS,
    //   })
    // );
    yield put({ type: "SIGNOUT" });
  }
}

function* signOutSuccessSaga() {
  yield put(
    apiResponseMessage({
      showMessage: true,
      message: <FormattedMessage id="logout-sucess" />,
      messageType: MESSAGE_TYPE.SUCCESS,
    }),
  );
}

export default function* rootSaga() {
  yield takeLatest(SIGNIN, signIn);
  yield takeLatest(REFRESH_TOKEN, refreshTokenSaga);
  yield takeLatest(SIGNOUT, signOutSuccessSaga);
}
